/*eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { DistanceFilter } from './DistanceFilter';
import { ProviderFilter } from './ProviderFilter';
import { LanguageFilter } from './LanguageFilter';
import {
  setSearchProviderFilters,
  resetSearchProviderFilters,
  setSearchProviderParams,
  setSearchParamsForUI,
  setShowAllFiltersPanel,
  setProviderType,
} from '../../../../../redux/admin/priceCompareSlice';
import {
  getPriceComaperFilters,
  searchProviders,
} from '../../../../../redux/admin/api-calls/priceCompare';
import { BestMatchFilter } from './BestMatchFilter';
import { MAXIMUM_FIND_PRICE_COMPARE_RADIUS } from 'src/constants';
import GenericButton from '../../../../../Components/GenericButton/GenericButton';
import AllFilterOptions from './AllFilterOptions';
import './InLineSearchFilter.scss';
import { t } from 'i18next';

const InLineSearchFilter = (props) => {
  const { providerType, searchParamsForUI } = useSelector(
    ({ priceCompareAdmin }) => priceCompareAdmin,
  );
  const [showAllFilters, setShowAllFilters] = useState(false);
  const dispatch = useDispatch();
  const allFilters = useSelector(
    ({ priceCompareAdmin }) => priceCompareAdmin.searchProviderParams.filters,
  );
  const { Provider, Gender, maximumradius, spokenlanguages } = allFilters;
  const filtersValuesList = useSelector(
    ({ priceCompareAdmin }) => priceCompareAdmin.filtersValuesList,
  );
  const typesOfSpecialtyData = '';

  const onChangeHandler = async (paramName, value) => {
    if (paramName !== 'spokenlanguages') {
      dispatch(setSearchProviderFilters({ [paramName]: value }));
    }
    if (paramName === 'Provider') {
      if (value === 'facility') {
        dispatch(
          setSearchParamsForUI({
            ...searchParamsForUI,
            ...{ providerByData: 'facility-type' },
          }),
        );
        dispatch(
          setSearchProviderParams({
            pagenumber: 1,
            speciality: null,
            facilityname: null,
            AcceptingNewPatients: false,
            Network: searchParamsForUI?.networksData?.value,
            filters: {
              Provider: 'facility',
              maximumradius: MAXIMUM_FIND_PRICE_COMPARE_RADIUS,
              Gender: '',
            },
          }),
        );
      } else {
        dispatch(
          setSearchParamsForUI({
            ...searchParamsForUI,
            ...{ providerByData: 'doctor-type' },
          }),
        );
        dispatch(
          setSearchProviderParams({
            pagenumber: 1,
            DoctorByType: null,
            DoctorByName: null,
            AcceptingNewPatients: false,
            Network: searchParamsForUI?.networksData?.value,
            filters: {
              Provider: 'doctor',
              maximumradius: MAXIMUM_FIND_PRICE_COMPARE_RADIUS,
              Gender: '',
            },
          }),
        );
      }
    }
    if (paramName === 'spokenlanguages') {
      if (value) {
        const valuesToSave = value.map((val) => {
          return val.value;
        });
        dispatch(setSearchProviderFilters({ spokenlanguages: valuesToSave }));
      } else {
        dispatch(setSearchProviderFilters({ spokenlanguages: null }));
      }
    }
  };

  const applyAllFilters = (selectedOptions) => {
    dispatch(setSearchProviderFilters(selectedOptions));
    setShowAllFilters(false);
  };

  const resetFilters = () => {
    dispatch(resetSearchProviderFilters());
  };
  return (
    <>
      <Row className="inline-filter-bar">
        <Col md={2} xs={6} className="sort-by-column">
          <div className="filter-data">
            <Row className="align-items-center">
              <Col xs={5} className="pr-0">
                <p>
                  <b>{t('find_provider.sort_by')} : </b>
                </p>
              </Col>
              <Col xs={7} className="p-0">
                <BestMatchFilter
                  onChangeBestMatchEvent={(val) =>
                    props.onChangeBestMatchEvent(val)
                  }
                />
              </Col>
            </Row>
          </div>
        </Col>
        <Col xs={6} className="d-block d-md-none">
          <div className="filter-data text-right">
            <GenericButton
              onClick={() => setShowAllFilters(!showAllFilters)}
              variant="secondary"
            >
              {t('find_provider.filter')}
            </GenericButton>
          </div>
        </Col>
        <Col md={10} className="d-none d-md-block">
          <div className="filter-data">
            <Row>
              <Col md={9}>
                <Row>
                  <Col md={3}>
                    <Row className="align-items-center">
                      <Col xs={6} className="pr-0">
                        <p>
                          <b>Provider : </b>
                        </p>
                      </Col>
                      <Col xs={6} className="p-0">
                        <ProviderFilter
                          value={Provider}
                          onChange={(event) => {
                            onChangeHandler('Provider', event.value);
                            props.onChangeGenderEvent(event.value);
                          }}
                          inputClassName="height-32 search-filter-component"
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md={3} className="p-0 ml-2">
                    <Row className="align-items-center">
                      <Col xs={5} className="pr-0">
                        <p>
                          <b>Distance : </b>
                        </p>
                      </Col>
                      <Col xs={6} className="p-0">
                        <DistanceFilter
                          value={maximumradius}
                          onChange={(event) => {
                            onChangeHandler('maximumradius', event.value);
                            props.onChangeDistanceEvent(event.value);
                          }}
                          inputClassName="height-32 search-filter-component"
                        />
                      </Col>
                    </Row>
                  </Col>
                  {Provider !== 'facility' && (
                    <Col md={5}>
                      <Row className="align-items-center">
                        <Col xs={4} className="pr-0">
                          <p>
                            <b>Language : </b>
                          </p>
                        </Col>
                        <Col xs={7} className="p-0">
                          <LanguageFilter
                            value={spokenlanguages}
                            onChange={(event) => {
                              onChangeHandler('spokenlanguages', event);
                              props.onChangeLanguageEvent(event);
                            }}
                            inputClassName="height-32 search-filter-component"
                            data={filtersValuesList.ListOfDoctorLanguages}
                          />
                        </Col>
                      </Row>
                    </Col>
                  )}
                </Row>
              </Col>
              <Col md={3} className="text-right">
                <GenericButton
                  id="reset-filter-button"
                  variant="link"
                  onClick={() => {
                    resetFilters();
                  }}
                >
                  {t(
                    'member.price_comparison.provider_container.reset_filters',
                  )}
                </GenericButton>
                <GenericButton
                  id="show-all-filters-button"
                  className="show-all-filter show-all-filters-button"
                  onClick={() => setShowAllFilters(!showAllFilters)}
                  variant="secondary"
                >
                  {t(
                    'member.price_comparison.provider_container.show_all_filters',
                  )}
                </GenericButton>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      <AllFilterOptions
        isVisible={showAllFilters}
        onHide={() => {
          setShowAllFilters(false);
        }}
        //filters={allFilters}
        onApply={applyAllFilters}
      />
    </>
  );
};

export default InLineSearchFilter;
